import { createSelector } from '@reduxjs/toolkit'

import { selectCurrentUser } from '@/modules/accounts'
import type { RootState } from '@/store/root-reducer'

import { notificationsAdapter } from './store/notifications-slice'
import type { Notification } from './types'

const selectAllNotifications = notificationsAdapter.getSelectors((state: RootState) => state.notifications).selectAll

/** The signed-in user's notifications, newest first. Read ones are kept for history. */
export const selectMyNotifications = createSelector(
  [selectAllNotifications, selectCurrentUser],
  (notifications, user): Notification[] =>
    user
      ? notifications
          .filter((notification) => notification.recipientUserId === user.id)
          .toSorted((a, b) => b.createdAt.localeCompare(a.createdAt))
      : [],
)

export const selectUnreadCount = createSelector(
  [selectMyNotifications],
  (notifications): number => notifications.filter((notification) => !notification.readAt).length,
)
